import React from 'react';
import TemplateImage from './TemplateImage';
import findSize from '../../utils/findSize';
import { Sizes } from '../../utils/types';

// a height or width should be specified for each image
// and corresponding maximum for rows and columns where possible

type SocialLayoutProps = {
  sizes: Sizes;
};

export default function SocialLayout({ sizes }: SocialLayoutProps) {
  return (
    <div className="select-none overflow-hidden p-8">
      <div className="mx-auto flex w-full flex-col items-end gap-4 overflow-hidden">
        <div className="flex flex-row items-end justify-end gap-4">
          <TemplateImage size={findSize(sizes, 1080, 1920)} height={360} />
          <div className="flex max-h-[400px] max-w-[260px] flex-col items-start gap-4">
            <TemplateImage size={findSize(sizes, 820, 360)} width={182} />
            <TemplateImage size={findSize(sizes, 1200, 1200)} width={260} />
          </div>
        </div>
        <div className="flex max-w-[470px] flex-row items-start gap-4">
          <TemplateImage size={findSize(sizes, 1200, 600)} height={100} top />
          <TemplateImage size={findSize(sizes, 1200, 628)} height={150} top />
        </div>
      </div>
    </div>
  );
}
